export const ESignatureProduct = 'ShareFile - E-Signature';
export type EventMetadata = object;

export const SignatureRequestSentTrackEvent = 'Signature Request Sent';
export const SelfSignedTrackEvent = 'Self Signed';
export const EditedSignatureRequestSentEvent = 'Signature Request revision completed';
export const StartedSignatureRequestEditTrackEvent = 'Signature Request revision started';
export const SignatureRequestProgressSavedEvent = 'Signature Request progress saved';
export const SignatureRequestDeclinedEvent = 'Signature Request declined';
export const SignatureRequestSignedEvent = 'Signature Request signed';
export const SignatureRequestExecutedEvent = 'Signature Request executed';
export const BulkSend = 'Bulk Send';

const ESIGN_BULK_SEND = 'esignBulkSend';
const ESIGN_FOOTER_ANALYTICS_PREFIX = 'esignFooter';
const ESIGN_HEADER_ANALYTICS_PREFIX = 'esignHeaderCloseIcon';

// Do we need to change this prefix?
const DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX = 'DocgenSendSignatureRequest';

// Footer Next Button AnalyticsId
export const FooterNextButtonAnalyticsIds = {
	StartPage: `${ESIGN_FOOTER_ANALYTICS_PREFIX}NextButton-StartPage`,
	PreparePage: `${ESIGN_FOOTER_ANALYTICS_PREFIX}NextButton-PreparePage`,
	ReviewPageSaveCompletedDocument: `${ESIGN_FOOTER_ANALYTICS_PREFIX}SaveCompletedDocumentButton-ReviewPage`,
	ReviewPageSendSignatureRequest: `${ESIGN_FOOTER_ANALYTICS_PREFIX}SendSignatureRequestButton-ReviewPage`,
};

// Footer Previous Button AnalyticsId
export const FooterPreviousButtonAnalyticsIds = {
	PreparePage: `${ESIGN_FOOTER_ANALYTICS_PREFIX}PreviousButton-PreparePage`,
	ReviewPage: `${ESIGN_FOOTER_ANALYTICS_PREFIX}PreviousButton-ReviewPage`,
};

// Header close icon AnalyticsId
export const HeaderCloseIconAnalyticsIds = {
	StartPage: `${ESIGN_HEADER_ANALYTICS_PREFIX}-StartPage`,
	PreparePage: `${ESIGN_HEADER_ANALYTICS_PREFIX}-PreparePage`,
	ReviewPage: `${ESIGN_HEADER_ANALYTICS_PREFIX}-ReviewPage`,
};

// Send Signature Request Footer Button AnalyticsId
export const SendSignatureRequestFooterAnalyticsIds = {
	NextStepSelectRecipients: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-NextButton-AddRecipientsPage`,
	NextStepAddFieldData: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-NextButton-AddFieldDataPage`,
	PreviousStepReviewAndSend: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-PreviousButton-ReviewPage`,
	PreviousStepAddFieldData: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-PreviousButton-AddFieldDataPage`,
	Customize: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-CustomizeButton`,
	SendSignatureRequest: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-SendSignatureRequestButton-ReviewPage`,
	StartOver: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-StartOverButton`,
	PreviousStepSelectRecipients: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-PreviousButton-AddRecipientsPage`,
};

export const BulkSendAnalyticsIds = {
	DeleteCSVFileConfirmationModal: {
		CancelButton: `${ESIGN_BULK_SEND}-DeleteCSVFileConfirmationModal-CancelButton`,
		CloseButton: `${ESIGN_BULK_SEND}-DeleteCSVFileConfirmationModal-CloseButton`,
		DeleteButton: `${ESIGN_BULK_SEND}-DeleteCSVFileConfirmationModal-DeleteButton`,
	},
	ImportSignersModal: {
		CloseButton: `${ESIGN_BULK_SEND}-ImportSignersModal-CloseButton`,
		BrowseFiles: `${ESIGN_BULK_SEND}-ImportSignersModal-BrowseFiles`,
		DownloadCSVTemplate: `${ESIGN_BULK_SEND}-ImportSignersModal-DownloadCSVTemplate`,
	},
	ImportConfirmationModal: {
		CloseButton: `${ESIGN_BULK_SEND}-ImportConfirmationModal-CloseButton`,
		ImportSigners: `${ESIGN_BULK_SEND}-ImportConfirmationModal-ImportSigners`,
		ChooseDifferentFile: `${ESIGN_BULK_SEND}-ImportConfirmationModal-ChooseDifferentFile`,
	},
	RemoveCSVFile: `${ESIGN_BULK_SEND}-RemoveCSVFile`,
	StartBulkSendButton: `${ESIGN_BULK_SEND}-StartBulkSendButton`,
};
